import { Theme } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import React from 'react'
import {IGlobalError, useGlobalError} from '../../context/GlobalError'
import {GlobalErrorNotification} from './GlobalNotification'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    apiNotification: {
      position: 'absolute',
      top: 64,
      right: 8,
      minHeight: 250,
    },
  })
)

export const GlobalErrorNotifications = () => {
  const {errors, removeError} = useGlobalError()
  const classes = useStyles()

  return (
    <div aria-live="polite" aria-atomic="true" className={classes.apiNotification}>
      {errors.map((error: IGlobalError) => (
        <GlobalErrorNotification
          key={error.guid}
          onClose={() => removeError(error.guid)}
          error={error}
        />
      ))}
    </div>
  )
}
